module.exports = __webpack_public_path__ + "img/Caribbean_Meal_Jerk_Tofu.fa778377.jpg";